/* tslint:disable */
/* eslint-disable */
/**
 * wicky_ups
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../Components/api/runtime';
import {
    StationDetailWithChannel,
    StationDetailWithChannelFromJSON,
    StationDetailWithChannelFromJSONTyped,
    StationDetailWithChannelToJSON,
    Ups,
    UpsFromJSON,
    UpsFromJSONTyped,
    UpsToJSON,
    UpsStatus,
    UpsStatusFromJSON,
    UpsStatusFromJSONTyped,
    UpsStatusToJSON,
    UpsSummaryAllOf,
    UpsSummaryAllOfFromJSON,
    UpsSummaryAllOfFromJSONTyped,
    UpsSummaryAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpsSummary
 */
export interface UpsSummary {
    /**
     * 
     * @type {string}
     * @memberof UpsSummary
     */
    deviceId: string;
    /**
     * 
     * @type {number}
     * @memberof UpsSummary
     */
    manageSerial: number;
    /**
     * 
     * @type {UpsStatus}
     * @memberof UpsSummary
     */
    firstStatusLog?: UpsStatus;
    /**
     * 
     * @type {UpsStatus}
     * @memberof UpsSummary
     */
    lastStatusLog?: UpsStatus;
    /**
     * 
     * @type {StationDetailWithChannel}
     * @memberof UpsSummary
     */
    station?: StationDetailWithChannel;
}

export function UpsSummaryFromJSON(json: any): UpsSummary {
    return UpsSummaryFromJSONTyped(json, false);
}

export function UpsSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deviceId': json['deviceId'],
        'manageSerial': json['manageSerial'],
        'firstStatusLog': !exists(json, 'firstStatusLog') ? undefined : UpsStatusFromJSON(json['firstStatusLog']),
        'lastStatusLog': !exists(json, 'lastStatusLog') ? undefined : UpsStatusFromJSON(json['lastStatusLog']),
        'station': !exists(json, 'station') ? undefined : StationDetailWithChannelFromJSON(json['station']),
    };
}

export function UpsSummaryToJSON(value?: UpsSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deviceId': value.deviceId,
        'manageSerial': value.manageSerial,
        'firstStatusLog': UpsStatusToJSON(value.firstStatusLog),
        'lastStatusLog': UpsStatusToJSON(value.lastStatusLog),
        'station': StationDetailWithChannelToJSON(value.station),
    };
}


